<template>
  <div>
    <v-btn flat class="delete-btn delete-btn-dash text-none" @click="dashboardDelete()" v-if="dashboardAccessLevel !== 'public' || isAdmin">
      <v-img :src="deleteDashboard" alt="delete_dashboard" width="15px" height="15px" ></v-img>
      <span style="margin-top: 2px">Delete</span>
    </v-btn>
    <v-dialog
      transition="dialog-top-transition"
      class="save-dashboard"
      width="600"
      v-model="showDeleteConfirmation"
    >
      <!-- <v-alert title="Delete Dashboard" text="Are you sure you want to delete dashboard ?">
                <v-btn variant="tonal" class="text-none" @click="closeDeleteConfirmation">Cancel</v-btn>
                <v-btn color="error" class="text-none" text @click="confirmDeleteDashboard" :loading="loading">Delete</v-btn>
            </v-alert> -->
      <template v-slot:default="{ isActive }">
        <v-card>
          <v-card-title class="d-flex align-center justify-between">
            <v-spacer></v-spacer>
            <v-btn
              @click="closeDeleteConfirmation"
              flat
              icon
              class="chart-preview-close-btn"
              size="x-small"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="mt-4 mx-5">
            <h6 class="text-center">Delete Dashboard</h6>
            <p class="text-center">
              Are you sure you want to delete dashboard?
            </p>
          </v-card-text>
          <v-card-actions class="btn-wrap">
            <v-btn class="cancel-btn" @click="isActive.value = false">
              <span>Cancel</span>
            </v-btn>
            <v-btn
              class="delete-btn"
              @click="confirmDeleteDashboard"
              :loading="loading"
              v-if="dashboardAccessLevel !== 'public' || isAdmin"
            >
              <img class="mr-2" :src="deleteDashboardPopup" width="15px" height="15px" alt="delete_dashboard" />
              <span>Delete</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "DeleteDashboard",
  data() {
    return {
      deleteDashboard: require("../../../assets/Svg/Chart/delete-white.svg"),
      deleteDashboardPopup: require("../../../assets/Svg/Chart/delete-white.svg"),
      showDeleteConfirmation: false,
      loading: false,
    };
  },
  props: {
    dashboard_id: {
      type: String,
    },
    dashboard_name: {
      type: String,
    },
    isAdmin: {
      type: Boolean,
    },
    dashboardAccessLevel: {
      type: String,
    }
  },
  methods: {
    dashboardDelete() {
      this.showDeleteConfirmation = true; // Show the confirmation alert
    },

    closeDeleteConfirmation() {
      this.showDeleteConfirmation = false; // Hide the alert
    },
    confirmDeleteDashboard() {
      const tenantId = getTenantPrefix() || "";
      const dashboardId = this.dashboard_id;
      const dashboardName = this.dashboard_name;
      var defaultDashboard = localStorage.getItem("defaultDashboard")

      this.loading = true;

      axios
        .delete(
          process.env.VUE_APP_API_URL +
            "public/api/dashboards/" +
            dashboardId,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
              "X-TenantID": tenantId,
            },
          }
        )
        .then((response) => {
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            this.loading = false;
            this.showDeleteConfirmation = false;
            if(dashboardName === defaultDashboard){
              localStorage.removeItem("defaultDashboard")
            }
            localStorage.removeItem("lastVisitedDashboard");
            localStorage.removeItem("dashboard")
            this.$emit("dashboard-delete");
          }
          else if (response && response.data && response.data.message) {
            console.error(response.data.message);
          }
          else {
            console.error("Error deleting dashboard");
          }
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED") {
            this.timeoutMessage = `Request timeout. Try again`;
          }
          this.loading = false;
        });
    },
  },
};
</script>